import { createFileRoute } from "@tanstack/react-router"
import { AppointmentSourcesPage } from "@/pages/appointment-sources"

export const Route = createFileRoute("/(analytics)/appointment-sources")({
	component: AppointmentSourcesPage,
})
